// extracted by mini-css-extract-plugin
export var label = "_ce-5";
export var slideContainer = "_ce-0";
export var slider = "_ce-1";
export var sliderLg = "_ce-4";
export var sliderMd = "_ce-3";
export var sliderSm = "_ce-2";